import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import AuthShell, { AuthLabel, AuthInput, AuthPrimaryButton, AuthErrorLine, formatApiErrorDetail } from "../components/AuthShell";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      setDone(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      setError(formatApiErrorDetail(err?.response?.data?.detail) || "Reset failed");
    } finally { setLoading(false); }
  };

  return (
    <AuthShell
      eyebrow="CUSTOMER · NEW PASSWORD"
      title="Set a new password."
      footer={
        <p className="font-mono text-[10px] tracking-[0.3em] text-off-white/60">
          <Link to="/login" className="text-rose hover:text-off-white">← BACK TO SIGN IN</Link>
        </p>
      }
    >
      {!token ? (
        <p className="mt-10 text-center text-off-white/70">Missing or invalid reset token.</p>
      ) : done ? (
        <div className="mt-10 border border-rose/30 bg-rose/5 p-6 text-center" data-testid="reset-success">
          <p className="font-mono text-[10px] tracking-[0.3em] text-rose mb-2">// PASSWORD UPDATED</p>
          <p className="text-off-white/80 text-sm">Redirecting you to sign in…</p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-10 space-y-4" data-testid="reset-form">
          <div>
            <AuthLabel>NEW PASSWORD (MIN 8)</AuthLabel>
            <AuthInput type="password" value={password} onChange={(e) => setPassword(e.target.value)} autoFocus required minLength={8} data-testid="reset-password-input" />
          </div>
          <AuthErrorLine error={error} />
          <AuthPrimaryButton type="submit" loading={loading} disabled={password.length < 8} data-testid="reset-submit-btn">
            UPDATE PASSWORD <ArrowRight size={16} />
          </AuthPrimaryButton>
        </form>
      )}
    </AuthShell>
  );
};

export default ResetPassword;
